import React from "react";
import { useSelector } from "react-redux";
import moment from "moment";
import commaNumber from "comma-number";
import "../../../../components/common/bt.css";

const format = commaNumber.bindWith(",", ".");

const SupplierLedgerPrintView = () => {
  const { list, openingBalance, closingBalance } = useSelector(
    (state) => state.supplierLedger
  );

  const totals = list.reduce(
    (acc, row) => {
      acc.debit += Number(row.debit_amount || 0);
      acc.credit += Number(row.credit_amount || 0);
      return acc;
    },
    { debit: 0, credit: 0 }
  );

  return (
    <table className="ledger-print-table">
      <colgroup>
        <col style={{ width: "4%" }} />
        <col style={{ width: "10%" }} />
        <col style={{ width: "30%" }} />
        <col style={{ width: "14%" }} />
        <col style={{ width: "11%" }} />
        <col style={{ width: "10%" }} />
        <col style={{ width: "10%" }} />
        <col style={{ width: "11%" }} />
      </colgroup>
      <tbody>
        <tr className="ledger-print-heading">
          <td>No.</td>
          <td>Date</td>
          <td>Particular</td>
          <td>VCH No</td>
          <td>VCH Type</td>
          <td style={{ textAlign: "right" }}>Debit</td>
          <td style={{ textAlign: "right" }}>Credit</td>
          <td style={{ textAlign: "right" }}>Balance</td>
        </tr>

        <tr className="ledger-opening-row">
          <td colSpan={7} style={{ textAlign: "right" }}>
            Opening Balance
          </td>
          <td style={{ textAlign: "right" }}>
            {format(parseFloat(openingBalance || 0).toFixed(2))}
          </td>
        </tr>

        {list.map((row, index) => {
          const date = moment(row.created_date);
          return (
            <tr key={`${row.id || index}-${row.created_date}`}>
              <td>{index + 1}</td>
              <td>{date.isValid() ? date.format("YYYY-MMM-DD") : "-"}</td>
              <td dangerouslySetInnerHTML={{ __html: row.particular }} />
              <td   style={{
    maxWidth: "150px",
    wordBreak: "break-word",
    whiteSpace: "normal",
  }}>{row.vch_no}</td>
              <td>{row.vch_type}</td>
              <td style={{ textAlign: "right" }}>
                {format(parseFloat(row.debit_amount || 0).toFixed(2))}
              </td>
              <td style={{ textAlign: "right" }}>
                {format(parseFloat(row.credit_amount || 0).toFixed(2))}
              </td>
              <td style={{ textAlign: "right" }}>
                {format(parseFloat(row.balance || 0).toFixed(2))}
              </td>
            </tr>
          );
        })}

        <tr className="ledger-total-row">
          <td colSpan={5} style={{ textAlign: "right" }}>
            Grand Total
          </td>
          <td style={{ textAlign: "right" }}>{format(totals.debit.toFixed(2))}</td>
          <td style={{ textAlign: "right" }}>{format(totals.credit.toFixed(2))}</td>
          <td />
        </tr>

        <tr className="ledger-closing-row">
          <td colSpan={7} style={{ textAlign: "right" }}>
            Closing Balance
          </td>
          <td style={{ textAlign: "right" }}>
            {format(parseFloat(closingBalance || 0).toFixed(2))}
          </td>
        </tr>
      </tbody>
    </table>
  );
};

export default SupplierLedgerPrintView;
